import { IAMAPI } from 'iam/API'
import Workspace from 'iam/models/Workspace'
import WorkspaceStore from 'iam/WorkspaceStore'
import { CursorPaged, Id } from 'types/definitions'
import { JoinWorkspaceAsAdminPort, ListAvailableWorkspacesQuery } from './ports'

export class JoinWorkspaceAsAdminAdapter implements JoinWorkspaceAsAdminPort {
  constructor(
    private workspaceStore: WorkspaceStore,
    private api: IAMAPI,
  ) {}

  /**
   * Lists workspaces available for the user to join.
   */
  listAvailableWorkspaces = async (
    query: ListAvailableWorkspacesQuery,
  ): Promise<CursorPaged<Workspace>> => {
    const result = await this.workspaceStore.find({
      after: query.pagination?.after ?? null,
      limit: query.pagination?.limit ?? 10,
      searchText: query.searchText,
    })

    const filtered = filterWorkspaces(result, query)

    return {
      data: filtered,
      cursor: result.cursor,
    }
  }

  /**
   * Joins a workspace as an admin with owner role.
   */
  joinWorkspaceAsAdmin = (workspaceId: string) =>
    this.api.platformAdmin.joinWorkspaceAsAdmin(workspaceId).then(() => {})

  /**
   * Promotes the current user to owner in the given workspace.
   */
  promoteToOwner = (workspaceId: string) =>
    this.api.platformAdmin.promoteToOwner(workspaceId).then(() => {})
}

function filterWorkspaces(
  page: CursorPaged<Workspace>,
  query: ListAvailableWorkspacesQuery,
): Workspace[] {
  // Filter out workspaces the user is already a member of.
  let filtered = page.data.filter(
    (ws) => !query.excludeWorkspaceIds.includes(Id.assert(ws.id)),
  )

  // Filter out e2e workspaces.
  filtered = filtered.filter((ws) => {
    const nameLower = ws.name.toLowerCase()
    const slugLower = ws.slug.toLowerCase()
    return !nameLower.includes('e2e') && !slugLower.includes('e2e')
  })

  return filtered
}
